/**
 * movnw Currency Converter
 * Lightweight currency switcher for Shopify stores.
 *
 * Set Shopify money format to: <span class="money">${{amount}}</span>
 *
 * Config is injected by the Liquid section. Override window.MOVNW_CURRENCY_CONFIG before loading.
 */

// Inject hiding CSS immediately — before browser renders prices
(function(){var s=document.createElement('style');s.textContent='.money{opacity:0!important}.movnw-currency-ready .money{opacity:1!important;transition:opacity .15s}';document.head.appendChild(s);})();

(function () {
  'use strict';

  // ============================================================
  // DEFAULT CONFIG — overridden by Liquid section
  // ============================================================
  const DEFAULT_CONFIG = {
    currencies: [
      { code: 'USD', symbol: '$', name: 'US Dollar' },
      { code: 'EGP', symbol: 'E£', name: 'Egyptian Pound' },
      { code: 'EUR', symbol: '€', name: 'Euro' },
      { code: 'GBP', symbol: '£', name: 'British Pound' },
      { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal' },
      { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
    ],
    defaultCurrency: 'USD',
    position: 'bottom-left',
    offsetX: 20,
    offsetY: 20,
    width: 'auto',           // CSS width (e.g. '200px', 'auto', '100%')
    bgColor: '#ffffff',
    textColor: '#0b1815',
    borderColor: '#52b69a',
    borderRadius: 8,
    fontSize: 15,
    shadow: false,
    autoDetect: true,
    showName: true,          // Show "EGP — Egyptian Pound" vs "EGP"
    placement: 'overlay',    // 'overlay' = fixed position | 'footer' = inline in #movnw-currency-footer
    rounding: 'none',        // 'none' | 'up' | 'down' | 'mround' | 'ceil' | 'floor'
    roundingMode: 'none',
    roundingFactor: 1,       // Factor for mround (e.g. 5 rounds to nearest 5), or decimals for ceil/floor
    smallPriceThreshold: 0,
    smallPriceMode: 'none',
    smallPriceFactor: 1,
  };

  const CONFIG = Object.assign({}, DEFAULT_CONFIG, window.MOVNW_CURRENCY_CONFIG || {});
  if (window.MOVNW_CURRENCY_CONFIG && window.MOVNW_CURRENCY_CONFIG.currencies) {
    CONFIG.currencies = window.MOVNW_CURRENCY_CONFIG.currencies;
  }

  const STORAGE_KEY = 'movnw_currency';
  // 4 fallback APIs — each tried in order before hardcoded rates
  const API_SOURCES = [
    {
      url: (codes) => `https://open.er-api.com/v6/latest/USD`,
      extract: (data, codes) => {
        var filtered = { USD: 1 };
        var allPresent = true;
        codes.split(',').forEach(function(c) {
          if (data.rates[c]) filtered[c] = data.rates[c];
          else allPresent = false;
        });
        return allPresent ? filtered : null;
      },
      name: 'ExchangeRate-API'
    },
    {
      url: (codes) => `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json`,
      extract: (data, codes) => {
        var filtered = { USD: 1 };
        var allPresent = true;
        codes.split(',').forEach(function(c) {
          var lc = c.toLowerCase();
          if (data.usd[lc]) filtered[c] = data.usd[lc];
          else allPresent = false;
        });
        return allPresent ? filtered : null;
      },
      name: 'CurrencyAPI (CDN)'
    },
    {
      url: (codes) => `https://www.floatrates.com/daily/usd.json`,
      extract: (data, codes) => {
        var filtered = { USD: 1 };
        var allPresent = true;
        codes.split(',').forEach(function(c) {
          var lc = c.toLowerCase();
          if (data[lc]) filtered[c] = data[lc].rate;
          else allPresent = false;
        });
        return allPresent ? filtered : null;
      },
      name: 'FloatRates'
    },
    {
      url: (codes) => `https://api.frankfurter.dev/v1/latest?base=USD&symbols=${codes}`,
      extract: (data, codes) => {
        var filtered = { USD: 1 };
        var allPresent = true;
        codes.split(',').forEach(function(c) {
          if (data.rates[c]) filtered[c] = data.rates[c];
          else allPresent = false;
        });
        return allPresent ? filtered : null;
      },
      name: 'Frankfurter'
    }
  ];
  const FALLBACK_RATES = { USD: 1, EGP: 50.5, EUR: 0.92, GBP: 0.79, SAR: 3.75, AED: 3.67, JPY: 155, CAD: 1.37, AUD: 1.53, CHF: 0.88, KWD: 0.31, BHD: 0.38, QAR: 3.64, OMR: 0.39, TRY: 34.5, INR: 83.5, PKR: 278, IQD: 1310, MAD: 9.9 };

  // ============================================================
  // STATE
  // ============================================================
  let rates = Object.assign({}, FALLBACK_RATES);
  let ratesLive = false;
  let observer = null;
  let currentCurrency = localStorage.getItem(STORAGE_KEY) || CONFIG.defaultCurrency;
  const allowedCodes = CONFIG.currencies.map(c => c.code);
  if (!allowedCodes.includes(currentCurrency)) {
    currentCurrency = CONFIG.defaultCurrency;
    localStorage.setItem(STORAGE_KEY, currentCurrency);
  }

  // ============================================================
  // FETCH EXCHANGE RATES
  // ============================================================
  async function fetchRates() {
    var codes = CONFIG.currencies.map(function(c) { return c.code; }).join(',');
    for (var i = 0; i < API_SOURCES.length; i++) {
      try {
        var source = API_SOURCES[i];
        var resp = await fetch(source.url(codes));
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        var data = await resp.json();
        var extracted = source.extract(data, codes);
        if (extracted && Object.keys(extracted).length > 1) {
          rates = extracted;
          ratesLive = true;
          console.log('[CurrencyConverter] Rates loaded from ' + source.name);
          return;
        }
      } catch (e) {
        console.warn('[CurrencyConverter] ' + source.name + ' failed:', e.message);
      }
    }
    // All APIs failed — use hardcoded fallback
    console.warn('[CurrencyConverter] All APIs failed, using hardcoded fallback rates');
    rates = Object.assign({}, FALLBACK_RATES);
  }

  // ============================================================
  // PRICE EXTRACTION
  // ============================================================
  function extractPrice(text) {
    if (!text) return null;
    let cleaned = text.replace(/[^\d.,]/g, '');
    if (!cleaned) return null;
    if (cleaned.includes(',') && cleaned.includes('.')) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (cleaned.includes(',')) {
      const parts = cleaned.split(',');
      cleaned = parts[parts.length - 1].length <= 2 ? cleaned.replace(',', '.') : cleaned.replace(/,/g, '');
    }
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }

  // ============================================================
  // FORMAT PRICE
  // ============================================================
  function formatPrice(amount, code) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount);
    } catch (e) {
      const cur = CONFIG.currencies.find(c => c.code === code);
      return (cur ? cur.symbol : code + ' ') + amount.toFixed(2);
    }
  }

  // ============================================================
  // ROUNDING
  // ============================================================
  function roundAmount(amount) {
    // Never round the store's default currency
    if (currentCurrency === CONFIG.defaultCurrency) return amount;

    var digitCount = String(Math.floor(Math.abs(amount))).length;
    var threshold = CONFIG.smallPriceThreshold;

    var mode, factor;
    if (typeof threshold === 'number' && threshold > 0 && digitCount < threshold) {
      mode = CONFIG.smallPriceMode || 'none';
      factor = CONFIG.smallPriceFactor || 1;
    } else {
      mode = CONFIG.roundingMode || CONFIG.rounding || 'none';
      factor = CONFIG.roundingFactor || 1;
    }

    if (mode === 'none' || factor <= 0) return amount;
    if (mode === 'up') return Math.ceil(amount / factor) * factor;
    if (mode === 'down') return Math.floor(amount / factor) * factor;
    if (mode === 'mround') return Math.round(amount / factor) * factor;
    if (mode === 'ceil') return Math.ceil(amount);
    if (mode === 'floor') return Math.floor(amount);
    return amount;
  }

  // ============================================================
  // CONVERT ALL PRICES
  // ============================================================
  function convertPrices() {
    try {
      if (observer) observer.disconnect();

      // Never convert with bundled fallback rates — only live API rates.
      // Stale hardcoded rates produce wrong prices; better to show USD
      // until the live fetch resolves (or its own timeout fires).
      if (!ratesLive) return;

      var rate = rates[currentCurrency];
      if (!rate) return;

      document.querySelectorAll('.money').forEach(function (el) {
        try {
          if (el.dataset.convertedPrice && el.textContent !== el.dataset.convertedPrice) {
            delete el.dataset.originalPrice;
          }
          if (!el.dataset.originalPrice) {
            var originalText = el.textContent;
            var price = extractPrice(originalText);
            if (price !== null) {
              el.dataset.originalPrice = price;
              el.dataset.hasSuffix = /[A-Z]{3}$/.test(originalText.trim()) ? '1' : '0';
            }
          }
          var original = parseFloat(el.dataset.originalPrice);
          if (isNaN(original)) return;
          var raw = original * rate;
          raw = roundAmount(raw);
          var converted = formatPrice(raw, currentCurrency);
          if (el.dataset.hasSuffix === '1') {
            converted += ' ' + currentCurrency;
          }
          if (el.textContent !== converted) {
            el.textContent = converted;
          }
          el.dataset.convertedPrice = converted;
        } catch (err) {
          console.error('[CurrencyConverter] Element error:', err);
        }
      });
    } catch (globalErr) {
      console.error('[CurrencyConverter] Global error:', globalErr);
    } finally {
      document.body.classList.add('movnw-currency-ready');
      if (observer) observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    }
  }

  // ============================================================
  // BUILD DROPDOWN
  // ============================================================
  // Globe SVG icon for footer mode (matches King theme localization element)
  var GLOBE_SVG = '<svg viewBox="0 0 70 70" fill="none" width="14" height="14"><mask id="movnw-globe-mask" maskUnits="userSpaceOnUse" x="0" y="1" width="69" height="69" fill="currentColor"><rect fill="white" y="1" width="69" height="69"></rect><path d="M18.4576 64.9096C18.4576 64.9096 18.5746 64.9757 18.6255 65.0011C23.3527 67.5551 28.7465 69 34.4919 69C38.6085 69 42.5571 68.247 46.2005 66.8886C54.5966 63.6326 61.1452 57.4968 64.8096 49.7481C66.8806 45.3218 68 40.5444 68 35.5025C68 32.4804 67.598 29.5499 66.8398 26.7619C62.9828 12.512 49.9457 2 34.5079 2H34.4926C16.0209 2 1 17.0288 1 35.4974C1 48.1707 8.07303 59.2161 18.4686 64.9038L18.4576 64.9096ZM46.8672 62.8643L45.2389 57.1357C44.9641 56.1589 45.3966 55.1414 46.282 54.6632L48.5871 53.4116C50.3986 52.4348 51.5181 50.5473 51.5181 48.4868C51.5181 47.7338 51.8844 47.0674 52.5358 46.6655C53.1718 46.2636 53.9402 46.2229 54.6221 46.5637L60.9776 49.7029C57.8635 55.4875 52.9022 60.1376 46.8829 62.8692L46.8672 62.8643Z" fill="currentColor"></path></mask><path d="M18.4576 64.9096C18.4576 64.9096 18.5746 64.9757 18.6255 65.0011C23.3527 67.5551 28.7465 69 34.4919 69C38.6085 69 42.5571 68.247 46.2005 66.8886C54.5966 63.6326 61.1452 57.4968 64.8096 49.7481C66.8806 45.3218 68 40.5444 68 35.5025C68 32.4804 67.598 29.5499 66.8398 26.7619C62.9828 12.512 49.9457 2 34.5079 2H34.4926C16.0209 2 1 17.0288 1 35.4974C1 48.1707 8.07303 59.2161 18.4686 64.9038L18.4576 64.9096Z" fill="currentColor"></path></svg>';

  function buildDropdown() {
    var existing = document.getElementById('movnw-currency-select');
    if (existing) existing.remove();

    var isFooter = CONFIG.placement === 'footer';
    var footerBottom = isFooter ? document.querySelector('.footer--bottom') : null;

    if (isFooter && footerBottom) {
      // ============ FOOTER MODE — inject next to localization-context inside first info block ============
      var localizationCtx = footerBottom.querySelector('localization-context');

      var wrapper = document.createElement('div');
      wrapper.id = 'movnw-currency-select';
      wrapper.style.cssText = 'position:relative;display:inline-flex;align-items:center;gap:6px;font-family:Montserrat,sans-serif;width:' + CONFIG.width + ';';

      // Button — code + symbol
      var curSymbol = (CONFIG.currencies.find(function(c) { return c.code === currentCurrency; }) || {}).symbol || '';
      var btn = document.createElement('div');
      btn.style.cssText =
        'display:inline-flex;align-items:center;cursor:pointer;padding:4px 0;' +
        'color:' + CONFIG.textColor + ';font-size:' + CONFIG.fontSize + 'px;font-weight:400;' +
        'letter-spacing:normal;line-height:1.5;white-space:nowrap;';
      btn.textContent = currentCurrency + ' ' + curSymbol;
      wrapper.appendChild(btn);

      // Dropdown menu — fixed position overlay, doesn't affect footer layout
      var menu = document.createElement('div');
      menu.style.cssText =
        'display:none;position:fixed;z-index:10000;' +
        'background:' + CONFIG.bgColor + ';border:1px solid ' + CONFIG.borderColor + ';' +
        'border-radius:' + CONFIG.borderRadius + 'px;padding:4px 0;min-width:120px;' +
        'box-shadow:0 4px 12px rgba(0,0,0,0.15);max-height:240px;overflow-y:auto;';

      CONFIG.currencies.forEach(function (c) {
        var item = document.createElement('div');
        item.style.cssText =
          'padding:6px 16px;cursor:pointer;font-size:' + CONFIG.fontSize + 'px;color:' + CONFIG.textColor + ';' +
          'font-family:Montserrat,sans-serif;white-space:nowrap;' +
          (c.code === currentCurrency ? 'font-weight:600;' : 'font-weight:400;');
        item.textContent = CONFIG.showName ? (c.code + ' — ' + c.name) : c.code;
        item.dataset.code = c.code;
        item.addEventListener('mouseenter', function () { item.style.backgroundColor = '#f0f0f0'; item.style.color = '#0b1815'; });
        item.addEventListener('mouseleave', function () { item.style.backgroundColor = 'transparent'; item.style.color = CONFIG.textColor; });
        item.addEventListener('click', function () {
          currentCurrency = c.code;
          localStorage.setItem(STORAGE_KEY, currentCurrency);
          btn.textContent = c.code + ' ' + c.symbol;
          menu.style.display = 'none';
          menu.querySelectorAll('div').forEach(function (d) {
            d.style.fontWeight = d.dataset.code === c.code ? '600' : '400';
          });
          convertPrices();
        });
        menu.appendChild(item);
      });

      wrapper.appendChild(menu);

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (menu.style.display === 'block') {
          menu.style.display = 'none';
        } else {
          // Position the fixed menu above the button
          var rect = btn.getBoundingClientRect();
          menu.style.left = rect.left + 'px';
          menu.style.bottom = (window.innerHeight - rect.top + 4) + 'px';
          menu.style.top = 'auto';
          menu.style.display = 'block';
        }
      });
      document.addEventListener('click', function () { menu.style.display = 'none'; });

      // Inject next to localization-context (sibling, same info-block)
      if (localizationCtx) {
        localizationCtx.parentNode.insertBefore(wrapper, localizationCtx.nextSibling);
        // Make the parent info-block use row layout so items are side by side
        localizationCtx.parentNode.style.flexDirection = 'row';
        localizationCtx.parentNode.style.alignItems = 'center';
        localizationCtx.parentNode.style.gap = '10px';
        localizationCtx.parentNode.style.flexWrap = 'wrap';
      } else {
        // Fallback: append to footer--bottom
        footerBottom.appendChild(wrapper);
      }

    } else {
      // ============ OVERLAY MODE — bordered select, original style ============
      var wrapper = document.createElement('div');
      wrapper.id = 'movnw-currency-select';

      var posStyle = '';
      var pos = CONFIG.position;
      // env(safe-area-inset-*) keeps the overlay clear of iPhone home-bar / notch UI
      if (pos.includes('bottom')) posStyle += 'bottom:calc(' + CONFIG.offsetY + 'px + env(safe-area-inset-bottom, 0px));';
      if (pos.includes('top')) posStyle += 'top:calc(' + CONFIG.offsetY + 'px + env(safe-area-inset-top, 0px));';
      if (pos.includes('left')) posStyle += 'left:' + CONFIG.offsetX + 'px;';
      if (pos.includes('right')) posStyle += 'right:' + CONFIG.offsetX + 'px;';
      wrapper.style.cssText = 'position:fixed;z-index:9999;font-family:Montserrat,sans-serif;width:' + CONFIG.width + ';' + posStyle;

      var chevronColor = encodeURIComponent(CONFIG.textColor);

      var select = document.createElement('select');
      select.style.cssText =
        'width:100%;padding:9px 38px 9px 20px;border:1px solid ' + CONFIG.borderColor + ';' +
        'border-radius:' + CONFIG.borderRadius + 'px;' +
        'background-color:' + CONFIG.bgColor + ';' +
        'background-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath fill=%27' + chevronColor + '%27 d=%27M6 8L0 0h12z%27/%3E%3C/svg%3E");' +
        'background-repeat:no-repeat;background-position:right 14px center;background-size:12px 8px;' +
        'color:' + CONFIG.textColor + ';font-size:' + CONFIG.fontSize + 'px;line-height:1.5;' +
        'cursor:pointer;outline:none;-webkit-appearance:none;appearance:none;min-height:auto !important;' +
        (CONFIG.shadow ? 'box-shadow:0 2px 8px rgba(0,0,0,0.12);' : '');

      CONFIG.currencies.forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c.code;
        opt.textContent = CONFIG.showName ? (c.code + ' — ' + c.name) : c.code;
        if (c.code === currentCurrency) opt.selected = true;
        select.appendChild(opt);
      });

      select.addEventListener('change', function () {
        currentCurrency = this.value;
        localStorage.setItem(STORAGE_KEY, currentCurrency);
        convertPrices();
      });

      wrapper.appendChild(select);
      document.body.appendChild(wrapper);
    }

    // Status indicator — always next to the selector, editor only
    if (window.Shopify && window.Shopify.designMode) {
      var dot = document.createElement('span');
      dot.id = 'movnw-rate-status';
      dot.title = ratesLive ? 'Live exchange rates' : 'Fallback rates (APIs blocked)';
      dot.style.cssText =
        'display:inline-block;width:8px;height:8px;border-radius:50%;vertical-align:middle;' +
        'background:' + (ratesLive ? '#22c55e' : '#f59e0b') + ';cursor:help;';
      // Append dot next to the selector
      wrapper.appendChild(dot);
    }
  }

  // ============================================================
  // AUTO-DETECT LOCATION
  // ============================================================
  async function detectLocation() {
    if (!CONFIG.autoDetect) return;
    if (localStorage.getItem(STORAGE_KEY)) return;
    var map = {
      EG: 'EGP', SA: 'SAR', AE: 'AED', GB: 'GBP',
      DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR',
      KW: 'KWD', BH: 'BHD', QA: 'QAR', OM: 'OMR',
      TR: 'TRY', IN: 'INR', PK: 'PKR', IQ: 'IQD',
      MA: 'MAD', JP: 'JPY', CA: 'CAD', AU: 'AUD', CH: 'CHF',
    };

    // Primary: Shopify edge geo-detection (instant, accurate, no extra request).
    var shopCountry = CONFIG.shopCountry;
    if (shopCountry) {
      var detected = map[shopCountry];
      if (detected && allowedCodes.includes(detected)) {
        currentCurrency = detected;
        localStorage.setItem(STORAGE_KEY, currentCurrency);
        return;
      }
    }

    // Fallback: IP geolocation (slower, can be skewed by VPN/relay).
    try {
      var resp = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(4000) });
      var data = await resp.json();
      var ipDetected = map[data.country_code];
      if (ipDetected && allowedCodes.includes(ipDetected)) {
        currentCurrency = ipDetected;
        localStorage.setItem(STORAGE_KEY, currentCurrency);
      }
    } catch (e) { /* silent */ }
  }

  // ============================================================
  // WATCH FOR DYNAMIC PRICES
  // ============================================================
  function watchForNewPrices() {
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () { convertPrices(); });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  // ============================================================
  // INIT
  // ============================================================
  // ============================================================
  // INIT
  // ============================================================
  // Clean up previous instance if reinitializing (e.g. theme editor setting change)
  if (window.__movnwCurrencyInitialized) {
    var oldDropdown = document.getElementById('movnw-currency-select');
    if (oldDropdown) oldDropdown.remove();
    if (typeof observer !== 'undefined' && observer) observer.disconnect();
    document.body.classList.remove('movnw-currency-ready');
    document.querySelectorAll('.money').forEach(function(el) {
      if (el.dataset.originalPrice) {
        el.textContent = formatPrice(parseFloat(el.dataset.originalPrice), 'USD');
      }
      delete el.dataset.originalPrice;
      delete el.dataset.convertedPrice;
    });
  }
  window.__movnwCurrencyInitialized = true;

  async function init() {
    // Build dropdown immediately (no prices yet)
    buildDropdown();
    watchForNewPrices();

    // Try to get live rates, with fallback after timeout
    var ratesReady = fetchRates().then(function() {
      ratesLive = true;
      convertPrices();
      var dot = document.getElementById('movnw-rate-status');
      if (dot) {
        dot.style.background = '#22c55e';
        dot.title = 'Live exchange rates';
      }
    }).catch(function(e) {
      console.warn('[CurrencyConverter] fetchRates failed:', e);
    });

    // Auto-detect location in parallel (non-blocking)
    if (!localStorage.getItem(STORAGE_KEY)) {
      detectLocation().then(function() {
        // Re-convert regardless of rate state — fallback rates are already
        // loaded, and when live rates arrive later they trigger their own
        // convertPrices(). Without this, first-load visitors see default
        // currency until they manually reload.
        convertPrices();
        var selectEl = document.querySelector('#movnw-currency-select select');
        if (selectEl && selectEl.value !== currentCurrency) {
          selectEl.value = currentCurrency;
        }
      }).catch(function(e) {
        console.warn('[CurrencyConverter] detectLocation failed:', e);
      });
    }

    // If live rates fail entirely, keep native USD prices (never convert
    // with stale bundled rates). Just reveal prices so they aren't stuck
    // behind the .money opacity mask.
    setTimeout(function () {
      if (!ratesLive) {
        console.warn('[CurrencyConverter] Live rates timed out — keeping store currency (USD)');
        document.body.classList.add('movnw-currency-ready');
      }
    }, 5000);
  }

  // Use DOMContentLoaded for faster init. Always re-run init on script load:
  // the cleanup block above removes any previous dropdown, so each copy that
  // loads (e.g. duplicate includes) rebuilds the overlay instead of leaving
  // the page with none.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
